import { Navigate } from 'react-router-dom';
import { ReactNode, JSX } from 'react';

interface Props {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: Props): JSX.Element {
  const token = localStorage.getItem('adminToken');
  
  // Kein Token vorhanden → zurück zum Login
  if (!token) {
    return <Navigate to="/adminlogin" />;
  }

  return <>{children}</>;
}